import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './components/ui/toast';
import { Layout } from './components/Layout';
import { AdminLayout } from './components/AdminLayout';
import { AdminRoute } from './components/AdminRoute';
import { Dashboard } from './pages/Dashboard';
import { TaskDetail } from './pages/TaskDetail';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminTaskDetail } from './pages/AdminTaskDetail';
import { UserManagement } from './pages/UserManagement';
import { TaskManagement } from './pages/TaskManagement';
import { Login } from './pages/Login';
import { Settings } from './pages/Settings';
import { GoogleCallbackHandler } from './components/GoogleCallbackHandler';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Router>
          <AuthProvider>
            <div className="min-h-screen bg-background text-foreground">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/google/callback" element={<GoogleCallbackHandler />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="tasks/:id" element={<TaskDetail />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              }>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="tasks" element={<TaskManagement />} />
                <Route path="tasks/:id" element={<AdminTaskDetail />} />
              </Route>
            </Routes>
          </div>
          </AuthProvider>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
